export enum LayoutType {
  DEFAULT = 'default',
  MANAGER = 'manager',
  CLIENT = 'client',
  SALES_REP = 'sales-rep',
  ADMIN = 'admin',
}
